import { PDP } from "../constants/ActionTypes";

const initialPDPState = {
  PRODUCT_DETAIL_ERROR: null,
  PRODUCT_DETAIL_MAIN: null,
  PRODUCT_SKU_DETAIL_INFO: null,
  PRODUCT_SKU_HTML: null,
  PRODUCT_DETAIL_IMAGE: null,
  PRODUCT_DETAIL_IMAGE_NOW: null,
  PRODUCT_DETAIL_IMAGE_NOW_TAG: null,
  PRODUCT_DETAIL_IMAGE_NOW_INDEX: null,
  PRODUCT_BREADCRUMB: null,
  PRODUCT_QA_LIST: null,
  PRODUCT_QA_LIST_PAGE: null,
  PRODUCT_COLLOCATION: null,
  PRODUCT_COMMENTS_LIST: null,
  PRODUCT_COMMENTS_LIST_PAGE: null,
  PRODUCT_SKU_PROMOTION_INFO: null,
  PRODUCT_SKU_PROMOTION_INFO_SHOW_MORE: false,
  PRODUCT_SKU_PROMOTION_COLOR_SHOW_MORE: false,
  PRODUCT_SKU_PROMOTION_COLOR_SELECTOR_SHOW_MORE: false,
  PRODUCT_USER_BUY_ONE_YEAR: false,
  PRODUCT_AD_GUESS: null,
  PRODUCT_AD_MAIN: null,
  PRODUCT_INVENTORY: 1,
  PRODUCT_GUESS_LIKE: null,
  PRODUCT_HTML_DOM: false,
  PRODUCT_COLOR_ITEM: null,
  PRODUCT_COLOR_GATHER: null,
  PRODUCT_COLOR_NESTED_INFO: null,
  PRODUCT_CHARACTER_ITEM: false,
  PRODUCT_SAVE_DATA: null,
  PRODUCT_SAVE_DEFULT_SKUID: null,
  PRODUCT_CHARACTER_LIST: null,
  PRODUCT_SAVE_END_DATA: null,
  PRODUCT_FILTER_CONDITION_DATA: null,
  PRODUCT_FILTER_CONDITION_CHARACTER_DATA: null,
  PRODUCT_STORAGE_COUNT: true,
  PRODUCT_BOOKING_STAUTUS: false,
  PRODUCT_SKU_PROMOTION_INFO_HANDLE_CLICK: false,
  PRODUCT_SKU_PROMOTION_INFO_GIFTS_DATA: null,
  PRODUCT_SKU_PROMOTION_INFO_GIFT_ID: "",
  PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX: 1,
  PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX: 1,
  PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX: 1,
  PRODUCT_SKU_PROMOTION_INFO_GIFT_FOUR_PX: 1,
  PRODUCT_SKU_PROMOTION_INFO_GIFT_FIFTH_PX: 1,
  PRODUCT_SKU_PROMOTION_INFO_RECORD_TIME: false,
  PRODUCT_GUERLAIN_ROUGE_OFFSET: null,
  PRODUCT_GUERLAIN_ENTER: null,
  PRODUCT_GUERLAIN_INFO: null,
  PRODUCT_GUERLAIN_INFO_URL: null,
  PRODUCT_GUERLAIN_INFO_CAP: null,
  PRODUCT_GUERLAIN_INFO_COLOR_PITCH_ON: null,
  PRODUCT_GUERLAIN_INFO_CAP_PITCH_ON: null,
  //miumiu
  PRODUCT_MIUMIU_INFO_URL: null,
  PRODUCT_MIUMIU_INFO: null,
  PRODUCT_MIUMIU_INFO_ODOR_PITCH_ON: null,
  PRODUCT_MIUMIU_INFO_CAP_PITCH_ON: null,
  PRODUCT_MIUMIU_INFO_TWO: null,
  PRODUCT_MIUMIU_INFO_THREE: null,
  PRODUCT_MIUMIU_INFO_LID_ON: null,
  PRODUCT_MIUMIU_INFO_BODY_ON: null,
  PRODUCT_MIUMIU_ENTER: null,

  PRODUCT_SKU_PROMOTION_INFO_GWP: 1,
  PRODUCT_VB_GIFT_LIST: null,
  PRODUCT_SKU_PROMOTION_INFO_THE_POSTS: 1,
  PRODUCT_POSTS_LIST: null,
  PRODUCT_POSTS_LIST_PAGE: 1,
  PRODUCT_COMMENTS_REASON: "",
  PRODUCT_COMMENTS_SWITCH: null,
  PRODUCT_COMMENTS_USE_OPID: null,
};

export default function (state = initialPDPState, action = {}) {
  switch (action.type) {
    //产品失效或者接口有问题跳转至404模块
    case PDP.PRODUCT_DETAIL_ERROR:
      return Object.assign({}, state, {
        PRODUCT_DETAIL_ERROR: action.PRODUCT_DETAIL_ERROR,
      });

    //主数据
    case PDP.PRODUCT_DETAIL_MAIN:
      return Object.assign({}, state, {
        PRODUCT_DETAIL_MAIN: action.PRODUCT_DETAIL_MAIN,
      });

    //产品主数据
    case PDP.PRODUCT_SKU_DETAIL_INFO:
      return Object.assign({}, state, {
        PRODUCT_SKU_DETAIL_INFO: action.PRODUCT_SKU_DETAIL_INFO,
      });

    //产品主数据html
    case PDP.PRODUCT_SKU_HTML:
      return Object.assign({}, state, {
        PRODUCT_SKU_HTML: action.PRODUCT_SKU_HTML,
        PRODUCT_SKU_DETAIL_INFO: action.PRODUCT_SKU_DETAIL_INFO,
      });

    //产品图片
    case PDP.PRODUCT_DETAIL_IMAGE:
      // if(action.PRODUCT_DETAIL_IMAGE[0] && action.PRODUCT_DETAIL_IMAGE[0].skuImagePath){
      return Object.assign({}, state, {
        PRODUCT_DETAIL_IMAGE: action.PRODUCT_DETAIL_IMAGE,
        PRODUCT_DETAIL_IMAGE_NOW:
          (action.PRODUCT_DETAIL_IMAGE[0] && action.PRODUCT_DETAIL_IMAGE[0].skuImagePath) || null,
        PRODUCT_DETAIL_IMAGE_NOW_TAG:
          (action.PRODUCT_DETAIL_IMAGE[0] &&
            action.PRODUCT_DETAIL_IMAGE[0].activityLabelImageUrl) ||
          null,
        PRODUCT_DETAIL_IMAGE_NOW_INDEX: 0,
      });
    // }else{
    //     return Object.assign({},state,{
    //         PRODUCT_DETAIL_IMAGE : action.PRODUCT_DETAIL_IMAGE,
    //         PRODUCT_DETAIL_IMAGE_NOW : null,
    //         PRODUCT_DETAIL_IMAGE_NOW_TAG:action.PRODUCT_DETAIL_IMAGE[0].activityLabelImageUrl,
    //         PRODUCT_DETAIL_IMAGE_NOW_INDEX : 0
    //     });
    // }
    //当前的产品图片
    case PDP.PRODUCT_DETAIL_IMAGE_NOW:
      return Object.assign({}, state, {
        PRODUCT_DETAIL_IMAGE_NOW: action.PRODUCT_DETAIL_IMAGE_NOW,
        PRODUCT_DETAIL_IMAGE_NOW_TAG: action.PRODUCT_DETAIL_IMAGE_NOW_TAG,
        PRODUCT_DETAIL_IMAGE_NOW_INDEX: action.PRODUCT_DETAIL_IMAGE_NOW_INDEX,
      });
    //当前的产品图片位置
    case PDP.PRODUCT_DETAIL_IMAGE_NOW_INDEX:
      return Object.assign({}, state, {
        PRODUCT_DETAIL_IMAGE_NOW_INDEX: action.PRODUCT_DETAIL_IMAGE_NOW_INDEX,
      });

    //面包削
    case PDP.PRODUCT_BREADCRUMB:
      return Object.assign({}, state, {
        PRODUCT_BREADCRUMB: action.PRODUCT_BREADCRUMB,
      });

    //获取评论列表
    case PDP.PRODUCT_COMMENTS_LIST:
      return Object.assign({}, state, {
        PRODUCT_COMMENTS_LIST: action.PRODUCT_COMMENTS_LIST,
      });
    //获取评论列表--页码
    case PDP.PRODUCT_COMMENTS_LIST_PAGE:
      return Object.assign({}, state, {
        PRODUCT_COMMENTS_LIST_PAGE: action.PRODUCT_COMMENTS_LIST_PAGE,
      });

    //获取QA列表
    case PDP.PRODUCT_QA_LIST:
      return Object.assign({}, state, {
        PRODUCT_QA_LIST: action.PRODUCT_QA_LIST,
      });
    //获取QA列表--页码
    case PDP.PRODUCT_QA_LIST_PAGE:
      return Object.assign({}, state, {
        PRODUCT_QA_LIST_PAGE: action.PRODUCT_QA_LIST_PAGE,
      });
    //校验用户一年内是否有购买记录
    case PDP.PRODUCT_USER_BUY_ONE_YEAR:
      return Object.assign({}, state, {
        PRODUCT_USER_BUY_ONE_YEAR: action.PRODUCT_USER_BUY_ONE_YEAR,
      });

    //搭配推荐
    case PDP.PRODUCT_COLLOCATION:
      return Object.assign({}, state, {
        PRODUCT_COLLOCATION: action.PRODUCT_COLLOCATION,
      });

    //sku促销信息
    case PDP.PRODUCT_SKU_PROMOTION_INFO:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_INFO: action.PRODUCT_SKU_PROMOTION_INFO,
        PRODUCT_SKU_PROMOTION_INFO_SHOW_MORE: false,
        PRODUCT_SKU_PROMOTION_COLOR_SHOW_MORE: false,
        PRODUCT_SKU_PROMOTION_COLOR_SELECTOR_SHOW_MORE: false,
      });
    //是否展示所有的sku促销信息
    case PDP.PRODUCT_SKU_PROMOTION_INFO_SHOW_MORE:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_INFO_SHOW_MORE: action.PRODUCT_SKU_PROMOTION_INFO_SHOW_MORE,
      });
    //是否展示所有颜色
    case PDP.PRODUCT_SKU_PROMOTION_COLOR_SHOW_MORE:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_COLOR_SHOW_MORE: action.PRODUCT_SKU_PROMOTION_COLOR_SHOW_MORE,
      });
    //是否展示所有颜色列表
    case PDP.PRODUCT_SKU_PROMOTION_COLOR_SELECTOR_SHOW_MORE:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_COLOR_SELECTOR_SHOW_MORE:
          action.PRODUCT_SKU_PROMOTION_COLOR_SELECTOR_SHOW_MORE,
      });
    //猜你喜欢广告位
    case PDP.PRODUCT_AD_GUESS:
      return Object.assign({}, state, {
        PRODUCT_AD_GUESS: action.PRODUCT_AD_GUESS,
      });
    //主广告位
    case PDP.PRODUCT_AD_MAIN:
      return Object.assign({}, state, {
        PRODUCT_AD_MAIN: action.PRODUCT_AD_MAIN,
      });
    //库存
    case PDP.PRODUCT_INVENTORY:
      return Object.assign({}, state, {
        PRODUCT_INVENTORY: action.PRODUCT_INVENTORY,
      });
    //猜你喜欢
    case PDP.PRODUCT_GUESS_LIKE:
      return Object.assign({}, state, {
        PRODUCT_GUESS_LIKE: action.PRODUCT_GUESS_LIKE,
      });
    //html是否执行了延迟加载
    case PDP.PRODUCT_HTML_DOM:
      return Object.assign({}, state, {
        PRODUCT_HTML_DOM: action.PRODUCT_HTML_DOM,
      });
    //点击色卡筛选系统，存储返回色系列表
    case PDP.PRODUCT_COLOR_ITEM:
      return Object.assign({}, state, {
        PRODUCT_COLOR_ITEM: action.PRODUCT_COLOR_ITEM,
      });
    case PDP.PRODUCT_COLOR_GATHER:
      return Object.assign({}, state, {
        PRODUCT_COLOR_GATHER: action.PRODUCT_COLOR_GATHER,
      });
    case PDP.PRODUCT_COLOR_NESTED_INFO:
      return Object.assign({}, state, {
        PRODUCT_COLOR_NESTED_INFO: action.PRODUCT_COLOR_NESTED_INFO,
      });
    case PDP.PRODUCT_CHARACTER_ITEM:
      return Object.assign({}, state, {
        PRODUCT_CHARACTER_ITEM: action.PRODUCT_CHARACTER_ITEM,
      });
    case PDP.PRODUCT_SAVE_DATA:
      return Object.assign({}, state, {
        PRODUCT_SAVE_DATA: action.PRODUCT_SAVE_DATA,
      });
    case PDP.PRODUCT_SAVE_DEFULT_SKUID:
      return Object.assign({}, state, {
        PRODUCT_SAVE_DEFULT_SKUID: action.PRODUCT_SAVE_DEFULT_SKUID,
      });
    case PDP.PRODUCT_CHARACTER_LIST:
      return Object.assign({}, state, {
        PRODUCT_CHARACTER_LIST: action.PRODUCT_CHARACTER_LIST,
      });
    case PDP.PRODUCT_SAVE_END_DATA:
      return Object.assign({}, state, {
        PRODUCT_SAVE_END_DATA: action.PRODUCT_SAVE_END_DATA,
      });
    case PDP.PRODUCT_FILTER_CONDITION_DATA:
      return Object.assign({}, state, {
        PRODUCT_FILTER_CONDITION_DATA: action.PRODUCT_FILTER_CONDITION_DATA,
      });
    case PDP.PRODUCT_FILTER_CONDITION_CHARACTER_DATA:
      return Object.assign({}, state, {
        PRODUCT_FILTER_CONDITION_CHARACTER_DATA: action.PRODUCT_FILTER_CONDITION_CHARACTER_DATA,
      });
    case PDP.PRODUCT_STORAGE_COUNT:
      return Object.assign({}, state, {
        PRODUCT_STORAGE_COUNT: action.PRODUCT_STORAGE_COUNT,
      });
    case PDP.PRODUCT_BOOKING_STAUTUS:
      return Object.assign({}, state, {
        PRODUCT_BOOKING_STAUTUS: action.PRODUCT_BOOKING_STAUTUS,
      });
    case PDP.PRODUCT_SKU_PROMOTION_INFO_HANDLE_CLICK:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_INFO_HANDLE_CLICK: action.PRODUCT_SKU_PROMOTION_INFO_HANDLE_CLICK,
      });
    case PDP.PRODUCT_SKU_PROMOTION_INFO_GIFTS_DATA:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_INFO_GIFTS_DATA: action.PRODUCT_SKU_PROMOTION_INFO_GIFTS_DATA,
      });
    case PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_ID:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_INFO_GIFT_ID: action.PRODUCT_SKU_PROMOTION_INFO_GIFT_ID,
      });
    case PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX:
          action.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX +
          state.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX,
      });
    case PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX:
          action.PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX +
          state.PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX,
      });
    case PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX:
          action.PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX +
          state.PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX,
      });
    case PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_FOUR_PX:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_INFO_GIFT_FOUR_PX:
          action.PRODUCT_SKU_PROMOTION_INFO_GIFT_FOUR_PX +
          state.PRODUCT_SKU_PROMOTION_INFO_GIFT_FOUR_PX,
      });
    case PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIFTH_PX:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_INFO_GIFT_FIFTH_PX:
          action.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIFTH_PX +
          state.PRODUCT_SKU_PROMOTION_INFO_GIFT_FIFTH_PX,
      });
    case PDP.PRODUCT_SKU_PROMOTION_INFO_GIFT_PX_EMPTY:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_INFO_GIFT_FIRST_PX: action.PRODUCT_SKU_PROMOTION_INFO_GIFT_PX_EMPTY,
        PRODUCT_SKU_PROMOTION_INFO_GIFT_SECOND_PX: action.PRODUCT_SKU_PROMOTION_INFO_GIFT_PX_EMPTY,
        PRODUCT_SKU_PROMOTION_INFO_GIFT_THIRD_PX: action.PRODUCT_SKU_PROMOTION_INFO_GIFT_PX_EMPTY,
      });
    case PDP.PRODUCT_SKU_PROMOTION_INFO_RECORD_TIME:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_INFO_RECORD_TIME: action.PRODUCT_SKU_PROMOTION_INFO_RECORD_TIME,
      });
    case PDP.PRODUCT_GUERLAIN_ROUGE_OFFSET:
      return Object.assign({}, state, {
        PRODUCT_GUERLAIN_ROUGE_OFFSET:
          action.PRODUCT_GUERLAIN_ROUGE_OFFSET + state.PRODUCT_GUERLAIN_ROUGE_OFFSET,
      });
    case PDP.PRODUCT_GUERLAIN_ENTER:
      return Object.assign({}, state, {
        PRODUCT_GUERLAIN_ENTER: action.PRODUCT_GUERLAIN_ENTER,
      });
    case PDP.PRODUCT_MIUMIU_ENTER:
      return Object.assign({}, state, {
        PRODUCT_MIUMIU_ENTER: action.PRODUCT_MIUMIU_ENTER,
      });

    case PDP.PRODUCT_GUERLAIN_INFO:
      return Object.assign({}, state, {
        PRODUCT_GUERLAIN_INFO: action.PRODUCT_GUERLAIN_INFO,
      });
    case PDP.PRODUCT_GUERLAIN_INFO_URL:
      return Object.assign({}, state, {
        PRODUCT_GUERLAIN_INFO_URL: action.PRODUCT_GUERLAIN_INFO_URL,
      });
    case PDP.PRODUCT_MIUMIU_INFO_URL:
      return Object.assign({}, state, {
        PRODUCT_MIUMIU_INFO_URL: action.PRODUCT_MIUMIU_INFO_URL,
      });
    case PDP.PRODUCT_MIUMIU_INFO:
      return Object.assign({}, state, {
        PRODUCT_MIUMIU_INFO: action.PRODUCT_MIUMIU_INFO,
      });
    case PDP.PRODUCT_MIUMIU_INFO_ODOR_PITCH_ON:
      return Object.assign({}, state, {
        PRODUCT_MIUMIU_INFO_ODOR_PITCH_ON: action.PRODUCT_MIUMIU_INFO_ODOR_PITCH_ON,
      });

    case PDP.PRODUCT_GUERLAIN_INFO_CAP:
      return Object.assign({}, state, {
        PRODUCT_GUERLAIN_INFO_CAP: action.PRODUCT_GUERLAIN_INFO_CAP,
      });
    case PDP.PRODUCT_MIUMIU_INFO_TWO:
      return Object.assign({}, state, {
        PRODUCT_MIUMIU_INFO_TWO: action.PRODUCT_MIUMIU_INFO_TWO,
      });
    case PDP.PRODUCT_MIUMIU_INFO_THREE:
      return Object.assign({}, state, {
        PRODUCT_MIUMIU_INFO_THREE: action.PRODUCT_MIUMIU_INFO_THREE,
      });
    case PDP.PRODUCT_MIUMIU_INFO_LID_ON:
      return Object.assign({}, state, {
        PRODUCT_MIUMIU_INFO_LID_ON: action.PRODUCT_MIUMIU_INFO_LID_ON,
      });
    case PDP.PRODUCT_MIUMIU_INFO_BODY_ON:
      return Object.assign({}, state, {
        PRODUCT_MIUMIU_INFO_BODY_ON: action.PRODUCT_MIUMIU_INFO_BODY_ON,
      });
    case PDP.PRODUCT_GUERLAIN_INFO_COLOR_PITCH_ON:
      return Object.assign({}, state, {
        PRODUCT_GUERLAIN_INFO_COLOR_PITCH_ON: action.PRODUCT_GUERLAIN_INFO_COLOR_PITCH_ON,
      });
    case PDP.PRODUCT_GUERLAIN_INFO_CAP_PITCH_ON:
      return Object.assign({}, state, {
        PRODUCT_GUERLAIN_INFO_CAP_PITCH_ON: action.PRODUCT_GUERLAIN_INFO_CAP_PITCH_ON,
      });
    case PDP.PRODUCT_MIUMIU_INFO_CAP_PITCH_ON:
      return Object.assign({}, state, {
        PRODUCT_MIUMIU_INFO_CAP_PITCH_ON: action.PRODUCT_MIUMIU_INFO_CAP_PITCH_ON,
      });
    case PDP.PRODUCT_SKU_PROMOTION_INFO_GWP:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_INFO_GWP:
          action.PRODUCT_SKU_PROMOTION_INFO_GWP + state.PRODUCT_SKU_PROMOTION_INFO_GWP,
      });
    case PDP.PRODUCT_VB_ISHIDE:
      return Object.assign({}, state, {
        PRODUCT_VB_ISHIDE: action.PRODUCT_VB_ISHIDE,
      });
    case PDP.PRODUCT_VB_GIFT_LIST:
      return Object.assign({}, state, {
        PRODUCT_VB_GIFT_LIST: action.PRODUCT_VB_GIFT_LIST,
      });
    case PDP.PRODUCT_SKU_PROMOTION_INFO_THE_POSTS:
      return Object.assign({}, state, {
        PRODUCT_SKU_PROMOTION_INFO_THE_POSTS:
          action.PRODUCT_SKU_PROMOTION_INFO_THE_POSTS + state.PRODUCT_SKU_PROMOTION_INFO_THE_POSTS,
      });
    case PDP.PRODUCT_POSTS_LIST:
      return Object.assign({}, state, {
        PRODUCT_POSTS_LIST: action.PRODUCT_POSTS_LIST,
        PRODUCT_POSTS_LIST_PAGE: action.PRODUCT_POSTS_LIST_PAGE,
      });
    case PDP.PRODUCT_COMMENTS_REASON:
      return Object.assign({}, state, {
        PRODUCT_COMMENTS_REASON: action.PRODUCT_COMMENTS_REASON,
      });
    case PDP.PRODUCT_COMMENTS_SWITCH:
      return Object.assign({}, state, {
        PRODUCT_COMMENTS_SWITCH: action.PRODUCT_COMMENTS_SWITCH,
        PRODUCT_COMMENTS_USE_OPID: action.PRODUCT_COMMENTS_USE_OPID,
      });
    case PDP.PRODUCT_GET_STANDING:
      return Object.assign({}, state, {
        PRODUCT_GET_STANDING: action.PRODUCT_GET_STANDING,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./common/reducers/productDetail.js